import { render, staticRenderFns } from "./ShardDetailView.vue?vue&type=template&id=3e7bf75f&scoped=true&"
import script from "./ShardDetailView.vue?vue&type=script&lang=js&"
export * from "./ShardDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ShardDetailView.vue?vue&type=style&index=0&id=3e7bf75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7bf75f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
